var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "div",
        { staticClass: "p-20 bg-white" },
        [
          _c(
            "div",
            { staticClass: "mb-20 flex align-center" },
            [
              _c("h4", { staticClass: "mr-10 mb-0 mt-0" }, [
                _vm._v("投诉单详情"),
              ]),
              _vm._v(" "),
              _c(
                "el-tag",
                {
                  attrs: {
                    size: "mini",
                    type:
                      _vm.info.complaint_state == "PROCESSED"
                        ? "primary"
                        : "danger",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.statu[_vm.info.complaint_state]) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "fs-s4" },
            [
              _c("el-col", { attrs: { xs: { span: 24 }, sm: { span: 12 } } }, [
                _c("div", { staticClass: "mb-10" }, [
                  _vm._v("投诉人openid：" + _vm._s(_vm.info.payer_openid)),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { xs: { span: 24 }, sm: { span: 12 } } }, [
                _c("div", { staticClass: "mb-10" }, [
                  _vm._v("联系方式：" + _vm._s(_vm.info.payer_phone)),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.info.complaint_order_info, function (item) {
                return [
                  _c(
                    "el-col",
                    { attrs: { xs: { span: 24 }, sm: { span: 12 } } },
                    [
                      _c("div", { staticClass: "mb-10" }, [
                        _vm._v("交易单号：" + _vm._s(item.transaction_id)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-10" }, [
                        _vm._v("商户单号：" + _vm._s(item.out_trade_no)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xs: { span: 24 }, sm: { span: 12 } } },
                    [
                      _c("div", { staticClass: "mb-10" }, [
                        _vm._v("订单金额：￥" + _vm._s(item.amount)),
                      ]),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-table",
            { staticClass: "mt-20", attrs: { data: _vm.list, border: "" } },
            [
              _c("el-table-column", {
                attrs: { label: "时间", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.RFCToDate(scope.row.operate_time)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "角色" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.operator) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "动作类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.operateType[scope.row.operate_type] || "--"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "内容" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.operate_details) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "图片" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _vm._l(scope.row.image_list, function (item) {
                              return [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px",
                                  },
                                  attrs: {
                                    src: item,
                                    "preview-src-list": scope.row.image_list,
                                  },
                                }),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-20" },
            [
              _vm.info.complaint_state != "PROCESSED"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.formDialog = true
                        },
                      },
                    },
                    [_vm._v("    留言    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.info.complaint_state != "PROCESSED"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "info" },
                      on: {
                        click: function ($event) {
                          return _vm.endComplaint()
                        },
                      },
                    },
                    [_vm._v("投诉处理完成")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "留言给用户", visible: _vm.formDialog },
          on: {
            "update:visible": function ($event) {
              _vm.formDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "130px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "留言内容" } },
                [
                  _c("el-input", {
                    attrs: { rows: "4", type: "textarea" },
                    model: {
                      value: _vm.formInfo.response_content,
                      callback: function ($$v) {
                        _vm.$set(_vm.formInfo, "response_content", $$v)
                      },
                      expression: "formInfo.response_content",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "图片凭证" } },
                [
                  _c("upload", {
                    attrs: {
                      emitUrl: false,
                      limit: 4,
                      action: "agentapi/analysis/wx_complaint_updimg",
                    },
                    model: {
                      value: _vm.formInfo.response_images,
                      callback: function ($$v) {
                        _vm.$set(_vm.formInfo, "response_images", $$v)
                      },
                      expression: "formInfo.response_images",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "fs-s3 text-gray" }, [
                    _vm._v("最多4张"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.formDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.postEdit()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }